module.exports = __webpack_public_path__ + "img/OPEN_NEW_TAB.d8aba6b8.svg";